export type Watch = {
  watching: boolean;
};
